import axios from "axios";
import { data } from "react-router-dom";

  //const BASE_URL = process.env.REACT_APP_API_URL || "https://service.ekumes.com.tr/api";
 //const BASE_URL = "http://localhost:3000/api";

const BASE_URL = process.env.REACT_APP_API_URL || "/api";


// Dış API için gerekli olan sabit WebToken.
const WEB_TOKEN = "U2VwcmFEb2x1bmF5YXJnZTExMTMzMy8qU29mdC0h";

// Axios instance'ı oluşturma
const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    WebToken: WEB_TOKEN,
  },
  timeout: 30000, // 30 saniye sonra zaman aşımı
});

// --- Hata Yönetimi Callback ---
let errorDisplayCallback = null;
export const setErrorDisplayCallback = (callback) => {
  errorDisplayCallback = callback;
};

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    //console.log("🔐 Interceptor çalıştı - Token:", token ? "VAR" : "YOK");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      // console.log(
      //   "🔑 Authorization header:",
      //   config.headers.Authorization.substring(0, 30) + "..."
      // );
    } else {
      // console.warn("⚠️ localStorage'da token yok!");
    }

    //console.log("📡 Request URL:", config.url);
    return config;
  },
  (error) => {
    // console.error("❌ Request interceptor hatası:", error);
    return Promise.reject(error);
  }
);


export const sendErrorEmail = (errorData) =>
  api.post("/error/send-email", errorData);

// --- Auth Servisleri ---
export const login = (data) => api.post("/auth/login", data);
export const smsVerify = (data) => api.post("/kumes/sms/verify", data);
export const logout = () => api.get("/auth/logout");
export const register = (data) => api.post("/kumes/register2", data);
export const getUserInfo = () => api.get("/bakici/user/uretici/bilgiler");

// --- Kümes CRUD Servisleri ---
export const getKumesler = () => api.get("/kumes/ ");
export const getKumesById = (id) => api.get(`/kumes/${id}`);
export const deleteKumes = (id) => api.delete(`/kumes/${id}`);
export const saveKullaniciKumesSecimi = (data) => {
  return api.post(`/kumes/eslesme/kaydet`, data);
};
export const saveKumes = (id, data) => {
  return api.post(`/kumes/${id}`, data);
};
export const deleteKullaniciEslesmesi = (ureticiId) => {
  // Backend router'da tanımladığımız DELETE metoduna ve endpoint'e istek atıyoruz.
  return axios.get(`/api/kumes/eslesme/${ureticiId}`);
};
export const KumesSaveDimensions = (data) => { 
  return api.post("/kumes/eslesme/saveDimensions", data);
};
export const SaveKlapeInfo = (data) => {
  return api.post("/kumes/eslesme/KlapeInfo", data); 
};
export const saveHeatingInfo = (data) => api.post("/kumes/eslesme/saveHeatingInfo", data);
export const SavePedInfo = (data) => api.post("/kumes/eslesme/savePedInfo", data);

// --- Kümes Form Tanımlamaları ---

export const getIller = () => api.get("/user/iller");
export const getIlceler = (ilId) => api.get(`/user/ilceler/${ilId}`);

export const getKumesCatiTipleri = () => api.get("/kumes/tanim/cati-tipleri");
export const getKlapeTipleri = () => api.get("/kumes/tanim/klape-tipleri");
export const getYakilTipleri = () => api.get("/kumes/tanim/yakit-tipleri");
export const getSobaTipleri = () => api.get("/kumes/tanim/soba-tipleri");
export const getSobaKonumlari = () => api.get("/kumes/tanim/soba-konumlari");
  export const getPedAdetleri = () => api.get("/kumes/tanim/ped-adetleri");
export const getUlkeKodlari = () => api.get("/bakici/definitions/UlkeKodlari");
export const getTanimEgitimDurumu = () =>
  api.get("/bakici/definitions/TanimEgitimDurumu");
export const getUreticiBakicilari = (ureticiId) =>
  api.get(`/bakici/user/kumes/UreticiBakicilari/${ureticiId}`);
export const postBakiciAdd = async (data) => {
  let response = await api.post("/bakici/process/bakici/add", data);
  // console.log("Bakıcı eklendi:", response.data);
  // console.log(`${data}`);

  return response;
};
export const getBakiciInfo = () => api.get("/bakici/user/uretici/bilgiler");
// Bakıcı güncelle
export const putBakiciUpdate = (data) => {
  // console.log("putBakiciUpdate çağrıldı, Data:", data);
  return api.post("/bakici/process/bakicilar/save", data);
};
//bakici sil
export const deleteBakici = (BAKICI_KULLANICI_ID, ureticiId) => {
  return api.get(`/bakici/user/delete/${BAKICI_KULLANICI_ID}/${ureticiId}`);
};

// Bakıcıyı kümesten çıkar (atamayı sil) - YENİ SERVİS
export const deleteBakiciKumesAtama = (KUMES_BAKICI_ES_ID) => {
  return api.get(`/bakici/process/bakici/bakicidanKumesSil/${KUMES_BAKICI_ES_ID}`);
};

// Bakıcıya kullanıcı oluştur
export const createBakiciKullanici = async (bakiciId, ureticiId) => {
  try {
    // Debug için log'lar
    // console.log("🔍 createBakiciKullanici çağrıldı");
    // console.log("📦 bakiciId:", bakiciId);
    // console.log("📦 ureticiId:", ureticiId);
    // console.log("🔑 Token:", localStorage.getItem("token") ? "VAR" : "YOK");

    const response = await api.post("/bakici/kullanici-olustur", {
      BAKICI_ID: bakiciId,
      URETICI_ID: ureticiId,
    });

    // console.log("✅ Response:", response.data);
    return response.data;
  } catch (error) {
    //console.error("❌ Bakıcıya kullanıcı oluşturma hatası:", error);
    //console.error("❌ Error response:", error.response?.data);
    //console.error("❌ Error status:", error.response?.status);
    //console.error("❌ Error config:", error.config);
    throw error;
  }
};

//bakici ata
export const postBakiciAtama = (atamaData) => {
  return api.post("/bakici/process/bakici/atama", atamaData);
};

export const getBakiciAtananKumesler = (bakiciId) => {
  // console.log("getBakiciAtananKumesler çağrıldı,bakıcı ID:", bakiciId);
  return api.get(`/bakici/process/bakici/AtananKumesler/${bakiciId}`);
};

export const getKumeseBakicilar = (KUMES_ID) =>
  api.get(`/bakici/user/kumes/bakicilar/${KUMES_ID}`);

// --- Kullanıcı ve Kümes Eşleştirme ---
export const getUsers = () => api.get("/user/kullanicilar");
export const getKullaniciKumesleri = (kullaniciId) =>
  api.get(`/kumes/eslesme/${kullaniciId}`);

// --- Üretim Dönemi ve Kümes Kartı ---
export const getDonemler = (kumesId) => {
  if (!kumesId)
    return Promise.reject(
      new Error("getDonemler çağrısı için Kümes ID sağlanmadı.")
    );
  return api.get(`/uretim/kumesler/${kumesId}/donemler`);
};
export const getKumesKartiBilgileri = (donemId, config) => {
  if (!donemId)
    return Promise.reject(
      new Error("getKumesKartiBilgileri çağrısı için Dönem ID sağlanmadı.")
    );
  return api.get(`/kumes/user/kumesKarti/bilgilerv2/${donemId}`, config);
};

export const getKumesKartiHindiBilgileri = (donemId, config) => { 
  if (!donemId)
    return Promise.reject(
      new Error("getKumesKartiHindiBilgileri çağrısı için Dönem ID sağlanmadı.")
    );
  return api.get(`/kumes/user/kumesKarti/hindi/bilgiler/${donemId}`, config); // ✅ DOĞRU
};

export const getDonemTakibi = (donemId) => {
  if (!donemId)
    return Promise.reject(
      new Error("getDonemTakibi çağrısı için Dönem ID sağlanmadı.")
    );
  return api.get(`/uretim/donem/takip/${donemId}`);
};
export const addPeriod = async (data) => {
  let response = await api.post("/uretim/donemler/create", data);
  // console.log(response);
  // console.log(data);
};

export const endPeriod = (periodData) => {
  if (!periodData || !periodData.DONEM_ID)
    return Promise.reject(
      new Error("endPeriod çağrısı için dönem verisi sağlanmadı.")
    );
  return api.post("/uretim/donemler/sonlandir", periodData);
};
export const getDonemSonlandirma = (kumesId, donemId) => {
  return axios.post(
    `https://portal.ekumes.com.tr/eKumesService/api/user/donemSonlandir/${kumesId}/${donemId}`,
    {},
    {
      withCredentials: true,
      responseType: "text",
    }
  );
};
export const getStokYemTipleri = (id) =>
  api.get(`/uretim/stok/tipler/yem/${id}`);

// export const addYemToKumesKarti = (data) =>
//   api.post("/kumes-karti/yem-ekle", data);
// export const addSuToKumesKarti = (data) =>
//   api.post("/kumes-karti/su-ekle", data);
export const deleteGunlukKayitFromKumesKarti = (donemId, gun) =>
  api.delete(`/kumes-karti/kayit-sil/${donemId}/${gun}`);
export const getKarZararGrafik = (params) =>
  api.get(
    `/muhasebe/kar-zarar/grafik/${params.kumesId}/${params.donemId}/${params.dovizId}`
  );
export const getZiyaretler = (donemId) =>
  api.get(`/uretim/ziyaretler/${donemId}`);
export const getAsilamalar = (donemId) => {
  if (!donemId)
    return Promise.reject(new Error("getAsilamalar için Dönem ID gerekli."));
  return api.get(`/veterinerlik/asilamalar/${donemId}`);
};
export const getZiyaretById = (id) => api.get(`/uretim/ziyaret/${id}`);
export const getVeterinerlerForZiyaret = (kumesId) =>
  api.get(`/uretim/veterinerler/liste/${kumesId}`);
export const addVisit = (data) => api.post("/uretim/ziyaretler/ekle", data);
export const updateVisit = (data) => api.post("/uretim/visit/save", data);
export const deleteVisit = (id) => api.get(`/uretim/visit/delete/${id}`);
export const deleteKumesKarti = (id, donemId) =>
  api.get(`/kumes-karti/delete/${id}/${donemId}`);



// --- Ekipman Servisleri ---
export const getYemlikler = (kumesId) => {
  if (!kumesId)
    return Promise.reject(new Error("getYemlikler için Kümes ID gerekli."));
  return api.get(`/uretim/ekipman/yemlikler/${kumesId}`);
};
export const getSuluklar = (kumesId) => {
  if (!kumesId)
    return Promise.reject(new Error("getSuluklar için Kümes ID gerekli."));
  return api.get(`/uretim/ekipman/suluklar/${kumesId}`);
};
export const addYemlik = (data) => api.post("/uretim/ekipman/yemlikler", data);
export const addSuluk = (data) => api.post("/uretim/ekipman/suluklar", data);
export const getYemlikTipleri = (kumesId) =>
  api.get(`/uretim/ekipman-tipleri/yemlik/${kumesId}`);
export const getSulukTipleri = (kumesId) =>
  api.get(`/uretim/ekipman-tipleri/suluk/${kumesId}`);
export const deleteYemlik = (id) =>
  api.get(`/uretim/ekipman/yemlikler/delete/${id}`);

export const deleteSuluk = (id) =>
  api.get(`/uretim/ekipman/suluklar/delete/${id}`);

// --- Stok Yönetimi ---
export const getStokYemler = (donemId) =>
  api.get(`/uretim/stok/yem/${donemId}`);
export const getStokKatkilar = (kumesId, donemId) =>
  api.get(`/uretim/stok/katki/${kumesId}/${donemId}`);
export const getStokIlaclar = (kumesId, donemId) =>
  api.get(`/uretim/stok/ilac/${kumesId}/${donemId}`);
export const getStokDezenfektanlar = (kumesId, donemId) =>
  api.get(`/uretim/stok/dezenfektan/${kumesId}/${donemId}`);
export const getStokYemById = (id) => api.get(`/uretim/stok/yem/${id}`);
export const getStokKatkiById = (id) => api.get(`/uretim/stok/katki/${id}`);
export const getStokIlacById = (id) => api.get(`/uretim/stok/ilac/${id}`);
export const getStokDezenfektanById = (id) =>
  api.get(`/uretim/stok/dezenfektan/${id}`);
export const addStokYem = (data) => api.post("/uretim/stok/yem", data);
export const addStokKatki = (data) => api.post("/uretim/stok/katki", data);
export const addStokIlac = (data) => api.post("/uretim/stok/ilac", data);
export const addStokDezenfektan = (data) =>
  api.post("/uretim/stok/dezenfektan", data);
export const updateStokYem = (data) => api.post(`/uretim/stok/yem/save`, data);
export const updateStokKatki = (data) =>
  api.post(`/uretim/stok/katki/save`, data);
export const updateStokIlac = (data) => api.post(`uretim/stok/ilac/save`, data);
export const updateStokDezenfektan = (data) =>
  api.post(`/uretim/stok/dezenfektan/save`, data);
export const deleteStokYem = (id) => api.post(`/uretim/stok/yem/delete/${id}`);
export const deleteStokKatki = (id) =>
  api.post(`/uretim/stok/katki/delete/${id}`);
export const deleteStokIlac = (id) =>
  api.post(`/uretim/stok/ilac/delete/${id}`);
export const deleteStokDezenfektan = (id) =>
  api.post(`/uretim/stok/dezenfektan/delete/${id}`);
export const getStokDezenfektanTipleri = (kumesId) =>
  api.get(`/uretim/stok/tipler/dezenfektan/${kumesId}`);
export const getAltlikTipleri = () =>
  api.get("/uretim/tanimlar/altlik-tipleri");
export const getMaliyetTipleri = () => api.get("/uretim/maliyet/tipler");
export const getDezenfektanDetay = (id) =>
  api.get(`/uretim/process/dezenfektanBilgiler/${id}`);
// Frontend service'inde kullanım
export const getEntDonemIlacBilgiler = (donemId) =>
  api.get(`/uretim/ent-donem-ilac/${donemId}`);
// --- Raporlama Servisleri ---
export const getUyariDonemleri = (kumesId) =>
  api.get(`/muhasebe/donemler/${kumesId}`);
export const getUyariListesi = ({ kullaniciId, cihazTokenId }) => {
  return api.post(`/uyarilar/listele`, { kullaniciId, cihazTokenId });
};
export const getKullaniciBildirimleri = ({ kullaniciId, cihazTokenId }) => {
  return api.post("/uyarilar/bildirimler", {
    kullaniciId,
    cihazTokenId,
  });
};

export const getUyariDetaylari = (uyariId) =>
  api.get(`/uyarilar/detay/${uyariId}`);
export const getMesajDetayi = (mesajId) =>
  api.get(`/uyarilar/mesaj/${mesajId}`);

export const getPerformansListesi = (kumesId) =>
  api.get(`/raporlar/performans/liste/${kumesId}`);
export const getPerformansGrafigi = (kumesId) =>
  api.get(`/raporlar/performans/grafik/${kumesId}`);
export const getMuhasebeDonemleri = (kumesId) =>
  api.get(`/muhasebe/donemler/${kumesId}`);
export const getKarZararRaporu = (params) =>
  api.get(
    `/muhasebe/kar-zarar/${params.kumesId}/${params.donemId}/${params.dovizId}`
  );
export const getMaliyetRaporuListe = (params) =>
  api.get(`/muhasebe/maliyet/liste/${params.kumesId}/${params.donemId}`);
export const getMaliyetRaporuGrafik = (params) =>
  api.get(`/muhasebe/maliyet/grafik/${params.kumesId}/${params.donemId}`);
export const getMaliyetRaporu = (params) =>
  api.get(`/muhasebe/maliyet/${params.kumesId}/${params.donemId}`);
export const getKatkiMaddesiTanimlari = (kumesId) =>
  api.get(`/uretim/tanimlamalar/katki-maddeleri/${kumesId}`);

// --- Diğer & Genel Servisler ---
export const getUreticiBilgileri = () => api.get("/user/uretici/bilgileri");
export const getKullaniciBilgileri = () => api.get("/user/info");
export const saveProducer = (data) => api.post("/user/info/save", data);
export const getHesapBilgileri = () => api.get("/hesap-bilgileri");

export const grafiklerService = {
  // Ölçüm tarihlerini getir
  getOlcumTarihleri: (donemId) =>
    api.get(`/grafikler/olcum-tarihleri/${donemId}`),

  // Belirli tarih verilerini getir
  getOlcumVerileri: (donemId, tarihGun) =>
    api.get(`/grafikler/olcum-verileri/${donemId}/${tarihGun}`),
};
export const getDestekTalepleri = (filterData) =>
  api.post("/destek/talepler/listele", filterData);
export const addDestekTalep = (talepData) =>
  api.post("/destek/talepler", talepData);
export const getDestekTalepById = (id) => api.get(`/destek/talepler/${id}`);
export const deleteDestekTalep = (id) => api.delete(`/destek/talepler/${id}`);
export const updateDestekTalep = (id, talepData) =>
  api.put(`/destek/talepler/${id}`, talepData);
export const getDestekDurumlari = () => api.get("/destek/durumlar");
export const addUser = (data) => api.post("/user/kullanicilar/ekle", data);
export const updateUser = (data) =>
  api.post("/user/kullanicilar/guncelle", data);
export const deleteUser = (id) => api.get(`/user/kullanicilar/sil/${id}`);
export const getUser = (id) => api.get(`/process/users/${id}`);
export const deleteAdditive = (id) =>
  api.delete(`/process/additive/delete/${id}`);
export const deleteVaccination = (id) =>
  api.delete(`/process/vaccination/delete/${id}`);
export const deleteManger = (id) => api.delete(`/process/manger/delete/${id}`);
export const deleteCoopcost = (id) =>
  api.delete(`/process/coopcost/delete/${id}`);
export const addAdditive = (data) => api.post("/process/additive/add", data);
export const updateAdditive = (data) =>
  api.post("/process/additive/save", data);
export const addVaccination = (data) =>
  api.post("/process/vaccination/add", data);
export const updateVaccination = (data) =>
  api.post("/process/vaccination/save", data);
export const addManger = (data) => api.post("/process/manger/add", data);
export const updateManger = (data) => api.post("/process/manger/save", data);
export const addCoopcost = (data) => api.post("/process/coopcost/add", data);
export const updateCoopcost = (data) =>
  api.post("/process/coopcost/save", data);
export const addEkipman = (data) => api.post("/ekipman/ekle", data);
export const updateEkipman = (id, data) =>
  api.put(`/ekipman/guncelle/${id}`, data);
export const deleteEkipman = (id) => api.delete(`/ekipman/sil/${id}`);

// --- Fan Yönetimi Servisleri ---
export const getFanlarByKumesId = (kumesId) =>
  api.get(`/kumes/${kumesId}/fanlar`);
export const updateFan = (fanId, data) => api.put(`/fanlar/${fanId}`, data);
export const getFanlar = (kumesId) => api.get(`/kumes/${kumesId}/fanlar`);
export const getBakicilar = (id) => api.get(`/kumes/${id}/bakicilar`);
export const getFanBoyutlari = () => api.get("/kumes/tanim/fan-boyutlari");
export const getFanGucleri = () => api.get("/kumes/tanim/fan-gucleri");
export const getFanKonumlari = () => api.get("/kumes/tanim/fan-konumlari");
export const getFanById = (fanId) => api.get(`/kumes/fan/${fanId}`);
export const addFan = (data) => api.post("/kumes/fan/ekle", data);
export const saveFan = (data) => api.post("/kumes/fan/kaydet", data);
export const deleteFan = (fanId) => api.get(`/kumes/fan/sil/${fanId}`);

export const getSirketlerForKumesForm = () => api.get("/kumes/tanim/sirketler");
export const getHayvanCinsleriForKumesForm = () =>
  api.get("/kumes/tanim/hayvan-cinsleri");
export const getIllerForKumesForm = () => api.get("/kumes/tanim/iller");
export const getIlcelerForKumesForm = (ilId) =>
  api.get(`/kumes/tanim/ilceler/${ilId}`);
export const getBolgelerForKumesForm = (sirketId) =>
  api.get(`/kumes/tanim/bolgeler/${sirketId}`);
export const getVeterinerlerForKumesForm = (sirketId) =>
  api.get(`/kumes/tanim/veterinerler/${sirketId}`);
export const getYemFabrikalariForKumesForm = (sirketId) =>
  api.get(`/kumes/tanim/yem-fabrikalari/${sirketId}`);
export const getUreticiBilgileriForKumesForm = () =>
  api.get("/kumes/tanim/uretici-bilgileri");
export const addKumes = (data) => api.post("/kumes/", data);
export const getIllerForRegister = () => api.get("/kumes/iller-for-register");
export const getIlcelerForRegister = (ilId) =>
  api.get(`/kumes/ilceler-for-register/${ilId}`);
export const getSirketlerForRegister = () =>
  api.get("/kumes/sirketler-for-register");

// --- Maliyet Yönetimi ---
export const getDonemMaliyetleri = (kumesId, donemId) =>
  api.get(`/uretim/maliyet/donem/${kumesId}/${donemId}`);
export const getKumesMaliyetleri = (kumesId) =>
  api.get(`/uretim/maliyet/kumes/${kumesId}`);
export const getDonemMaliyetTipleri = () =>
  api.get("/uretim/maliyet/tipler/donem");
export const getKumesMaliyetTipleri = () =>
  api.get("/uretim/maliyet/tipler/kumes");
export const addDonemMaliyeti = (data) =>
  api.post("/uretim/maliyet/donem", data);
export const addKumesMaliyeti = (data) =>
  api.post("/uretim/maliyet/kumes", data);
export const getOluHayvanImhaTipleri = () =>
  api.get("/kumes/tanim/imha-tipleri");
export const updateDonemMaliyeti = (data) =>
  api.post(`/uretim/maliyet/donem/save`, data);
export const updateKumesMaliyeti = (data) =>
  api.post(`/uretim/maliyet/kumes/save`, data);
export const deleteDonemMaliyeti = (id) =>
  api.get(`/uretim/maliyet/donem/sil/${id}`);
export const deleteKumesMaliyeti = (id) =>
  api.get(`/uretim/maliyet/kumes/sil/${id}`);
// export const getGrafikVerileri = (donemId) => {
//   if (!donemId)
//     return Promise.reject(
//       new Error("getGrafikVerileri için Dönem ID gerekli.")
//     );
//   return api.get(`/uretim/grafik/${donemId}`);
// }; //artık kullanılmıyor

//grafik servisleri yeni
// export const getOlcumTarihleri = (donemId) => {
//   if (!donemId) {
//     return Promise.reject(new Error("getOlcumTarihleri için Dönem ID gerekli."));
//   }
//   return api.get(`/user/olcumVeri/tarih/${donemId}`);
// };

// export const getOlcumVerileri = (donemId, tarihGun) => {
//   if (!donemId || !tarihGun) {
//     return Promise.reject(new Error("getOlcumVerileri için Dönem ID ve Tarih gerekli."));
//   }
//   return api.get(`/user/olcumVerileri/${donemId}/${tarihGun}`);
// };

// --- AŞILAMA SERVİSLERİ ---
export const getAsilamaTipleri = (kumesId) =>
  api.get(`/uretim/asilamalar/tipler/${kumesId}`);
export const getAsilamaById = (id) => api.get(`/uretim/asilama/${id}`);
export const addAsilama = (data) => api.post("/uretim/asilamalar/ekle", data);
export const updateAsilama = (data) =>
  api.post("/uretim/asilamalar/guncelle", data);
export const deleteAsilama = (id) => api.get(`/uretim/asilamalar/sil/${id}`);
export const getYemFabrikalariByKumes = (kumesId) => {
  if (!kumesId)
    return Promise.reject(
      new Error("getYemFabrikalariByKumes için Kümes ID gerekli.")
    );
  return api.get(`/uretim/stok/fabrikalar/yem/${kumesId}`);
};
export const getStokKatkiTipleri = (kumesId) =>
  api.get(`/uretim/stok/tipler/katki/${kumesId}`);
export const getStokIlacTipleri = (kumesId) =>
  api.get(`/uretim/stok/tipler/ilac/${kumesId}`);

// --- TANIMLAMA DETAYLARI (BİLGİ MODALI İÇİN) ---
export const getKatkiMaddesiDetay = (id) =>
  api.get(`/uretim/process/katkiMaddeleriBilgiler/${id}`);
export const getIlacDetay = (id) =>
  api.get(`/uretim/process/takviyeIlacBilgiler/${id}`);

//şifremi unuttum
export const sendForgotPasswordSms = (data) =>
  api.post("/user/sifre/unutma/sms", data);
export const verifyForgotPasswordSms = (data) =>
  api.post("/user/sifre/unutma/sms/dogrula", data);
export const setForgotPassword = (payload) =>
  api.post("/user/sifre/unutma/yeniSifre", payload);

// Kayıt Servisleri
export const registerKayit = (data) => api.post("/kayit/register", data);
export const getSirketlerKayit = () => api.get("/kayit/definitions/sirketler");
export const getIllerKayit = () => api.get("/kayit/definitions/iller");
export const getIlcelerKayit = (ilId) =>
  api.get(`/kayit/definitions/iller/${ilId}/ilceler`);
export const getEgitimDurumlariKayit = () =>
  api.get("/kayit/definitions/egitim-durumlari");
export const getUlkeKodlariKayit = () =>
  api.get("/kayit/definitions/ulke-kodlari");
export const sendKayitSms = (payload) =>
  api.post("/kayit/sms/olustur", payload);

export const verifyKayitSms = (payload) =>
  api.post("/kayit/sms/dogrula", payload);

//su tüketimi servisleri

// Su tüketimi servisleri - Düzeltilmiş
export const getSuTuketimi = (DONEM_ID) =>
  api.get(`/suverileri/getir/${DONEM_ID}`);

export const addSuTuketimi = (data) => api.post("/suverileri/add", data);

export const updateSuTuketimi = (data) => api.post("/suverileri/save", data);

export const deleteSuTuketimi = (id) =>
  api.post("/suverileri/delete", { DONEM_SU_TUKETIM_ID: id });

//kilo
export const getKiloVerileri = (donemId) =>
  api.get(`/agirlik/getir/${donemId}`);
export const addKilo = (data) => api.post("/agirlik/add", data);
export const deleteKilo = (id) =>
  api.post("/agirlik/delete", { DONEM_KILO_ID: id });

// Entegre Yem İstekleri
export const postEntBaitAdd = (data) => {
  return api.post("/bait/process/feed/request/add", data);
};

export const postEntBaitDelete = (data) => {
  return api.post("/bait/process/feed/request/delete", {yemTalepId : data});
};

export const getEntBaitList = (donemId) => {
  return api.get(`/bait/process/yem/istek/getir/${donemId}`);
};

// Entegresiz Yem İşlemleri
export const postBaitAdd = (data) => {
  return api.post("/bait/process/bait/add", data);
};

export const postBaitUpdate = (data) => {
  return api.post("/bait/process/bait/save", data);
};

export const postBaitDelete = (donemYemTuketimId) => {
  return api.post(`/bait/process/bait/delete/${donemYemTuketimId}`);
};

// Yem Bilgileri
export const getYemTipleri = (donemId) => {
  return api.get(`/bait/yem-tipleri/${donemId}`);
};

// Yem Stok Sorguları
export const getYemStokTavuk = (gunid, Sirketid) => {
  return api.get(`/bait/process/yem/mevcutStok/tavuk/${gunid}/${Sirketid}`);
};

export const getYemStokDisiHindi = (gunid, Sirketid) => {
  return api.get(`/bait/process/yem/mevcutStok/Dhindi/${gunid}/${Sirketid}`);
};

export const getYemStokErkekHindi = (gunid, Sirketid) => {
  return api.get(`/bait/process/yem/mevcutStok/Ehindi/${gunid}/${Sirketid}`); // ✅ Ehindi (büyük E)
};

//ölüm servisleri
export const addDeath = (data) => {
  return api.post(`/death/add/v2`, data);
};
export const deleteDeath = (id) => {
  return api.delete(`/death/delete/${id}`);
};
export const updateDeath = (data) => {
  return api.post(`/death/save`, data);
};
export const getolumler = (donemId) => {
  return api.get(`/death/list/${donemId}`);
};

export const addEntDeath = (data) => {
  return api.post(`/death/add/v2/entg`, data);
};

export const deleteEntDeath = (id) => {
  return api.delete(`/death/delete/entg/${id}`);
};
// --- Kamera Servisleri ---

// Kümese ait kameraları listeler (RTSP adresleri backend'de gizlenir)
export const getKumesKameralari = (KUMES_ID) =>
  api.get(`/camera/kumes/${KUMES_ID}`);

// Tüm kameralar (yönetim ekranı için)
export const getTumKameralar = () => api.get("/camera/tumu");

// HLS playlist adresi — <video> / hls.js'e verilecek tam URL
export const getKameraHlsUrl = (CIHAZ_CAM_ID) =>
  `${api.defaults.baseURL}/camera/hls/${CIHAZ_CAM_ID}/index.m3u8`;

export const getKameraSnapshotUrl = (CIHAZ_CAM_ID, ts) =>
  `${api.defaults.baseURL}/camera/snapshot/${CIHAZ_CAM_ID}${ts ? `?t=${ts}` : ""}`;